import { Finding } from "@pages/findings/types";

/**
 * Filters findings on the frontend.
 * This is only necessary with demo findings, since actual findings are filtered on the backend.
 * Only filtering by rule/ruleset and severity, because filtering by project, branch, and action
 * won't do anything.
 */
export const filterDemoFindings = (
  unfilteredFindings: Finding[],
  rulesString: string | null,
  rulesetString: string | null,
  severitiesString: string | null
) => {
  const rules = rulesString ? rulesString.split(",") : [];
  const rulesets = rulesetString ? rulesetString.split(",") : [];
  const severities =
    severitiesString !== null
      ? severitiesString.split(",").map((s) => parseInt(s))
      : [];

  let filteredFindings = unfilteredFindings;

  // filter rules and rulesets
  if (rules.length || rulesets.length) {
    filteredFindings = filteredFindings.filter((f) => {
      return (
        rules.find((r) => f.finding.check_id === r) !== undefined ||
        rulesets.find((r) => f.finding.metadata?.["semgrep.ruleset"] === r) !==
          undefined
      );
    });
  }

  // filter severity
  if (severities.length) {
    filteredFindings = filteredFindings.filter(
      (f) => severities.find((s) => s === f.finding.severity) !== undefined
    );
  }

  return filteredFindings;
};
